import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import DryftProjectList from './DryftProjectList';
import DryftConfigSetList from './DryftConfigSetList';
import DryftNotificationTargetList from './DryftNotificationTargetList';
import './ProfileIATAPage.css';
import './OperaCloudCompare.css';
import './AddPaymentPorterWizard.css';

// Dryft home — three tabs: Projects, Configuration Sets, Notification Targets. The active tab lives in
// the ?tab= query param so forms can navigate back to the right tab after save/cancel.

const TABS = [
    {
        key: 'config-sets',
        label: 'Configuration Sets',
        desc: 'Reusable, named bundles of the OHIP config areas you care about (e.g. “Rates” = Rate Codes + Packages). Build them once here, then pick them by name when you set up a project.',
    },
    {
        key: 'notification-targets',
        label: 'Notification Targets',
        desc: 'Reusable, named recipient groups — up to 3 email addresses and one Teams channel. A project sends its change alerts to a target, so you define who gets notified once and reuse it across projects.',
    },
    {
        key: 'projects',
        label: 'Projects',
        desc: 'Monitoring jobs. A project watches one or more hotels’ OHIP property configuration and, on a schedule (hourly or daily), alerts people when a watched area changes. Each project pairs a Configuration Set (what to watch) with a Notification Target (who to tell).',
    },
];

// The first tab is the default and owns the clean (no ?tab=) URL.
const DEFAULT_TAB = TABS[0].key;

const DryftHomePage = () => {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const tabParam = searchParams.get('tab');
    const activeTab = TABS.some(t => t.key === tabParam) ? tabParam : DEFAULT_TAB;

    const selectTab = (key) => setSearchParams(key === DEFAULT_TAB ? {} : { tab: key });
    const activeDesc = (TABS.find(t => t.key === activeTab) || {}).desc;

    return (
        <div className="pi-page">
            <div className="pi-header">
                <div className="pi-header-left">
                    <button className="pi-back-btn" onClick={() => navigate('/apps')}>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M10 3L5 8l5 5" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        Apps
                    </button>
                    <div className="pi-title-block">
                        <h1 className="pi-title">Dryft</h1>
                        <p className="pi-subtitle">OHIP property-config monitoring &amp; change alerts across many hotels</p>
                    </div>
                </div>
            </div>

            <div className="dryft-tabs">
                {TABS.map(t => (
                    <button
                        key={t.key}
                        className={`dryft-tab ${activeTab === t.key ? 'active' : ''}`}
                        onClick={() => selectTab(t.key)}
                    >
                        {t.label}
                    </button>
                ))}
            </div>

            {activeDesc && <p className="dryft-tab-desc">{activeDesc}</p>}

            {activeTab === 'projects' && <DryftProjectList />}
            {activeTab === 'config-sets' && <DryftConfigSetList />}
            {activeTab === 'notification-targets' && <DryftNotificationTargetList />}
        </div>
    );
};

export default DryftHomePage;
